import {api} from '@/api';
import utils from 'utils';

import {useContext, useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';

import {UiCheckbox, CartDeliveryOption} from '@components/export.ts';
import {useLabel} from '@/hooks/export';

import appContext from '@/appContext';

export const CartDelivery = (props: {
    readonly?: boolean,
    onDeliveryCheck?: (allowed: boolean) => void,
}) => {
    // todo: select delivery if single

    const label = useLabel();
    const queryClient = useQueryClient();

    const {cart} = useContext(appContext).cartContext;

    const handle = {
        selectDelivery(id: string, optionId: string, selected: boolean) {
            api.cart.updateDelivery({id, optionId, selected})
                .then(() => {
                    queryClient.invalidateQueries({
                        queryKey: ['cart'],
                    });
                });
        },
        checkDelivery() {
            const check = {
                id: false,
                optionId: false,
            };

            if (cart && cart.selectedDelivery) {
                Object.entries(cart.delivery).map(([deliveryItemId, deliveryItem]: [string, deliveryItem]) => {
                    if (deliveryItemId === cart.selectedDelivery.id) {
                        check.id = true;

                        if (Object.entries(deliveryItem.options).length && deliveryItem.optionsRequired) {
                            Object.entries(deliveryItem.options).map(([deliveryOptionId, deliveryOption]) => {

                                if (deliveryOptionId === cart.selectedDelivery.optionId && !deliveryOption.disabled) {
                                    check.optionId = true;
                                }
                            });
                        } else {
                            check.optionId = true;
                        }
                    }
                });
            }

            if (props.onDeliveryCheck !== undefined) {
                props.onDeliveryCheck(check.id && check.optionId);
            }
        },
        selectSingleDeliveryOption() {
            // fixme: any - delivery option, from BE

            if (cart && cart.delivery) {
                if (Object.entries(cart.delivery).length !== 1) {
                    return;
                }

                const [deliveryId, delivery]:[string, any] = Object.entries(cart.delivery)[0];

                if (Object.entries(delivery.options).length !== 1) {
                    return;
                }

                const [optionId, option]:[string, any] = Object.entries(delivery.options)[0];

                handle.selectDelivery(
                    deliveryId,
                    (option.selected || !option.selectable) ? optionId : '',
                    true,
                );
            }
        },
    };

    useEffect(() => {
        handle.checkDelivery();
        handle.selectSingleDeliveryOption();
    }, [cart]);

    return <div className={cmpClass}>
        {
            cart && cart.delivery ?
                Object.entries(cart.delivery).map(([deliveryItemId, deliveryItem]: [string, deliveryItem]) => {
                    return (!props.readonly || deliveryItem.selected) ?
                        <div className={classMap.item} key={deliveryItemId}>
                            <div className={classMap.box}>
                                <div className={classMap.info}>
                                    <div className={classMap.title}>{deliveryItem.name}</div>
                                    {
                                        deliveryItem.message ?
                                            <div className={classMap.message}>
                                                <span>{deliveryItem.message}</span>
                                            </div> : <></>
                                    }
                                </div>
                                <div className={classMap.state}>
                                    <div className={classMap.price}>
                                        {utils.formatPrice(deliveryItem.price) + ' ' + label.currency}
                                    </div>
                                    {
                                        !props.readonly ?
                                            <div className={classMap.selected}>
                                                <UiCheckbox
                                                    onChange={(selected) => handle.selectDelivery(deliveryItemId, '', selected)}
                                                    checked={deliveryItem.selected}
                                                />
                                            </div> :
                                            <></>
                                    }
                                </div>
                            </div>
                            {
                                Object.entries(deliveryItem.options).length ?
                                    <div className={classMap.options}>
                                        {
                                            Object.entries(deliveryItem.options).map(([deliveryOptionId, deliveryOption]) => {
                                                return !props.readonly || deliveryOption.selected || !deliveryOption.selectable ?
                                                    <div className={classMap.option} key={deliveryOptionId}>
                                                        <CartDeliveryOption
                                                            option={deliveryOption}
                                                            onChange={(selected) => handle.selectDelivery(deliveryItemId, deliveryOptionId, selected)}
                                                            readonly={props.readonly}
                                                        />
                                                    </div> : <></>;
                                            })
                                        }
                                    </div> :
                                    <></>
                            }
                        </div> : <></>;
                }) :
                <></>
        }
    </div>;
};

const cmpClass = 'cart-delivery';
const classMap = utils.generateClassMap(cmpClass, {
    item: 'item',
    box: 'box',
    info: 'info',
    title: 'title',
    options: 'options',
    option: 'option',
    message: 'message',
    state: 'state',
    selected: 'selected',
    price: 'price',
});
